import React from "react";
import {Button, Grid} from "@material-ui/core";
import Badge from '@material-ui/core/Badge';
import {useFormStyles} from './styles';

export function GetActionsButtons(actions = [], form, props, cleanValues) {
    const classes = useFormStyles();
    const handleReset = (e) => {
        e.preventDefault();
        return form.handleReset(e);
    };
    return actions.map((action, i) => {
        switch (action.props.type) {
            case 'submit':
                return <Grid item key={action.props.key + i}>
                    <Badge overlap="rectangular"
                        badgeContent={action?.badge} color={'default'}
                        className={classes.ButtonBadge}
                           anchorOrigin={{
                               vertical: 'bottom',
                               horizontal: 'right',
                           }}>
                        <Button type={'submit'} {...action.props}>{action.label}</Button>
                    </Badge>
                </Grid>;
            case 'cancel':
                return <Grid item key={action.props.key + i}>
                    <Button type={'button'} onClick={props.onCancel} {...action.props}>{action.label}</Button>
                </Grid>;
            case 'reset':
                return <Grid item key={action.props.key + i}>
                    <Button type={'reset'} {...action.props} onClick={action.onClick ?? handleReset}>{action.label}</Button>
                </Grid>;
            default:
                return <React.Fragment key={i}/>
        }
    })
}

